import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { advProducts: { getAdvProducts, } } = apiUrls;

export const ADV_PRODUCTS_SUCCESS = 'ADV_PRODUCTS_SUCCESS';
export const ADV_PRODUCTS_LOADING = 'ADV_PRODUCTS_LOADING';


export const getAdvProductsData = ({ country, fromdate, todate }) => async (dispatch) => {
        try {
            const { url } = getAdvProducts
            const requestData = {
                ...getAdvProducts,
                url: url.replace('{{country}}', country).
                replace('{{fromdate}}', fromdate).replace('{{todate}}', todate)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: ADV_PRODUCTS_SUCCESS,
                data,
            })
        } catch (e) {

            dispatch({
                type: ADV_PRODUCTS_SUCCESS,
                data: {
                    code: "",
                    modal: null,
                    notifications: null,
                    paginationInfo: null
                }
            })
        }

    }



export const handleLoader = isLoading => (dispatch) => {
    dispatch({
        type: ADV_PRODUCTS_LOADING,
        isLoading
    })
}
